import Vue from "vue";
import axios from "axios";
import store from "../store";
import { redirectToLogin } from "../utils/helpers";

import { loadProgressBar } from "axios-progress-bar";

const instance = axios.create({
    baseURL: window.location.origin.startsWith("http://localhost")
        ? "https://localhost:44307"
        : window.location.origin,
});

async function errorHandler(error) {
    if (error.response && error.response.status == 401) {
        redirectToLogin();

        return;
    }

    console.log(error);

    let text = "An error has occurred";

    // Handle blob error responses (when responseType was 'blob')
    if (error.response && error.response.data instanceof Blob) {
        try {
            const blobText = await error.response.data.text();
            const errorData = JSON.parse(blobText);
            text = errorData.Message || errorData.message || blobText;
        } catch (e) {
            // If parsing fails, use generic message
            console.error("Could not parse blob error response:", e);
        }
    } else if (error.response && error.response.data && error.response.data.Message) {
        text = error.response.data.Message;
    } else if (error.response && error.response.data && error.response.data.message) {
        text = error.response.data.message;
    } else if (error.response && typeof error.response.data === "string" && error.response.data) {
        text = error.response.data;
    }

    Vue.notify({
        group: "notification",
        text: text,
        type: "error",
    });

    throw new Error(text);
}
instance.interceptors.request.use(function(config) {
    config.headers.Authorization = store.state.authentication.token;

    return config;
});
instance.interceptors.response.use((response) => {
    return response ? response.data : response;
}, errorHandler);

loadProgressBar(null, instance);

Vue.prototype.$http = instance;
